import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';

export const forgotPasswordAction = {
    forgotPasswordHandler
};

function forgotPasswordHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.forgotPasswordHandler(data)
            .then(
                forgotPassword => {
                    dispatch(success(forgotPassword));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_FORGOT_PASSWORD} }
    function success(forgotPassword) { return { type: userProfileConstants.RECEIVE_FORGOT_PASSWORD, forgotPassword } }
    function failure(error) { return { type: userProfileConstants.FORGOT_PASSWORD_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/forgotPassword.action.js